import { Component, ComponentFactoryResolver, Input, OnDestroy, OnInit, Type, ViewChild } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { filter, first, map, takeUntil, tap } from 'rxjs/operators';
import { BrickInstancesSelectors } from '../../../../store/dashboard/brick-wall/brick-instances/brick-instances.selectors';
import { ComponentHostDirective } from '../../../general-directives/component-host.directive';
import { ISpecificBrickSettingsComponent } from './ISpecificBrickSettingsComponent';

@Component({
   selector: 'samweb-brick-specific-type-settings',
   templateUrl: './brick-specific-type-settings.component.html',
   styleUrls: ['./brick-specific-type-settings.component.scss'],
})
export class BrickSpecificTypeSettingsComponent implements OnInit, OnDestroy {
   private destroy$ = new Subject();

   @Input()
   public brickInstanceId: string;

   @ViewChild(ComponentHostDirective, { static: true })
   componentHost: ComponentHostDirective;

   public settingsComponent$: Observable<Type<ISpecificBrickSettingsComponent>>;

   constructor(private store: Store, private componentFactoryResolver: ComponentFactoryResolver) {}

   ngOnInit() {
      this.settingsComponent$ = this.store.select(BrickInstancesSelectors.getBrickSettingsComponentFn).pipe(map((fn) => fn(this.brickInstanceId)));

      this.settingsComponent$
         .pipe(
            filter((settingsComponent) => !_.isNil(settingsComponent)),
            // use first() to improve performance (if we need anytime dynamically changing setting components we have to improve this)
            first(),
            tap((settingsComponent) => {
               const componentFactory = this.componentFactoryResolver.resolveComponentFactory(settingsComponent);
               const viewContainerRef = this.componentHost.viewContainerRef;
               viewContainerRef.clear();
               const componentRef = viewContainerRef.createComponent<ISpecificBrickSettingsComponent>(componentFactory);
               componentRef.instance.brickInstanceId = this.brickInstanceId;
            }),
            takeUntil(this.destroy$)
         )
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
